module.exports = __webpack_public_path__ + "img/rounds.1f6694d7.png";